import { useStore } from './store'
import { Toolbar } from './components/Toolbar'
import { Player } from './components/Player'
import { Timeline } from './components/Timeline'
import { TranscriptPanel } from './components/TranscriptPanel'
import { ImportDropzone } from './components/ImportDropzone'
import { ClipList } from './components/ClipList'
import { LogoPanel } from './components/LogoPanel'
import { FormatPanel } from './components/FormatPanel'
import { StylePanel } from './components/StylePanel'
import { ChatBar } from './components/ChatBar'
import { StoryPanel } from './components/StoryPanel'
import { ProjectPanel } from './components/ProjectPanel'
import { Onboarding } from './components/Onboarding'
import { AboutModal } from './components/AboutModal'

export default function App() {
  const hasClips = useStore((s) => s.clips.length > 0)
  const status = useStore((s) => s.status)

  return (
    <div className="app">
      <Toolbar />

      {!hasClips ? (
        <ImportDropzone />
      ) : (
        <>
          <div className="workspace">
            <div className="left">
              <Player />
              <Timeline />
              <ClipList />
            </div>
            <div className="right">
              <StoryPanel />
              <StylePanel />
              <FormatPanel />
              <LogoPanel />
              <ProjectPanel />
              <TranscriptPanel />
            </div>
          </div>
          <ChatBar />
        </>
      )}

      <Onboarding />
      <AboutModal />
      <div className="statusbar">{status || 'Sẵn sàng.'}</div>
    </div>
  )
}
